const resetSwiperZoom = (swiper) => {
  if (swiper && swiper.zoom && swiper.zoom.scale > 1) {
    swiper.zoom.out();
  }
};

export default resetSwiperZoom;
